import React, {FC, useEffect} from "react";
import {ShopsPage} from "./shops-page";
import {useDispatch} from "react-redux";
import {getShops} from "../../../bll/app-reducer";
import {useSelector} from "../../../hooks/redux-hooks";


export const ShopsContainer: FC = () => {
    const dispatch = useDispatch()
    const {shops} = useSelector(state => state.app)
    useEffect(() => {
        dispatch(getShops())
    }, [])
    return <ShopsPage shops={shops}/>
}